import { useEffect } from "react";

import ButtonBase from "@mui/material/ButtonBase"
import Grid2 from "@mui/material/Grid2"
import Modal from "@mui/material/Modal"
import Typography from "@mui/material/Typography"

import useIntervalHandler from "../../hooks/useIntervalHandler";
import { ReactComponent as WifiIcon } from "../../svg/wifi.svg";
import styles from "./offlineModal.module.css"

const OfflineModal = ({ handleReload, isOnline }: { handleReload: () => void, isOnline: boolean }) => {
    const { startInterval, removeInterval } = useIntervalHandler(handleReload);

    useEffect(() => {
        startInterval(10000);
        return () => removeInterval();
    }, []);
    return (
        <Modal open={!isOnline} >
            <Grid2 className={styles.full_page} >
                <Grid2 className={styles.container} >
                    <Grid2 className={styles.offline_text}>
                        <Typography variant="swipe" >
                            You are offline
                        </Typography>
                        <Typography variant="caption4Light">
                            Please connect to the internet and try again
                        </Typography>
                    </Grid2>
                    <ButtonBase className={styles.button} onClick={handleReload} >
                        <Typography variant="ingredientText2paralell">
                            Reload
                        </Typography>
                    </ButtonBase>
                </Grid2>
                <WifiIcon />
            </Grid2>
        </Modal >

    )
}

export default OfflineModal